export default {
  setClassInfo(state, classEntity) {
    state.classInfo = classEntity;
  },

  setOrderInfo(state, studentOrderEntity) {
    state.orderInfo = studentOrderEntity;
  }
};
